import { ThunkDispatch } from "@reduxjs/toolkit";
import { DropdownActions } from "Components/Common/Actions/DropdownActions";
import DtsTablePlaceholder from "Components/Common/FormBuilder/DtsTablePlaceholder";
import { useDispatch } from "react-redux";
import { Badge, Button, Modal, ModalBody, ModalFooter, ModalHeader, Spinner, Table } from "reactstrap";
import SimpleBar from "simplebar-react";
import { viewCreateRequest } from "store/views/action";
import { getViewList, isJson } from "utils";
import { DragDropContext, Droppable, Draggable, DropResult } from 'react-beautiful-dnd';
import { useCallback, useEffect, useState } from "react";
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import DNDRow from "./DNDRow";
import { bulkUpdateRequest } from "store/bulk/action";



const ArrageViews = ({ props, show, onCloseClick, setupdatedViewOrder, setViews, updatedViewOrder,viewlist, setisDeleteOpen, setIsEditOpen, setRecord, setViewname, model, toggleTab,viewId , loading}: any) => {
    const dispatch: ThunkDispatch<any, null, any> = useDispatch(); 

    const [resultSequence, setResultSequence] = useState([])

    const onDuplicateView = (fields: any, viewname: any) => {
        let data = {
            "name": viewname,
            "primary": "true",
            "model": model,
            "location": "listing",
            "fields": JSON.stringify(fields),
            "filters": JSON.stringify([]),
        }
        const handleSuccess = (body: any) => {
            toggleTab(body?.id)
            getViewList(dispatch, model, "listing")
        }
        const handleFailure = () => {

        }
        dispatch(viewCreateRequest(data, model, handleSuccess, handleFailure))
    }

    const onEdit = (data: any) => {
        setIsEditOpen(true); setRecord(data); setViewname(data.name)
    }

    const onDuplicate = (item: any) =>  {
        let fields  =  item?.fields && isJson(item?.fields) ? JSON.parse(item?.fields) : item?.fields
        onDuplicateView(fields, `${item.name} copy`)
    }

    useEffect(() => {
        setupdatedViewOrder(viewlist)
    }, [viewlist])


    const onActivate = (item: any) =>  {
        toggleTab(item?.id)
        onCloseClick()
    }

    const extraActions = [{
        clickHandler: onEdit,
        btn_type: "btn-soft-secondary",
        btn_icon: "ri-pencil-fill",
        btn_name: props.t(`users.edit`),
        action: 'edit',
        module: model
    },
    {
        clickHandler: onDuplicate,
        btn_type: "btn-soft-info",
        btn_icon: "ri-file-copy-fill",
        btn_name: props.t(`users.duplicate`),
        action: 'create',
        module: model
    },
    {
        clickHandler: onActivate,
        btn_type: "btn-soft-success",
        btn_icon: "ri-checkbox-circle-line",
        btn_name: props.t(`users.activate`),
        conditionalField: 'id',
        conditionalFieldValue: viewId,
        hidePermission: true,
        skipPermission:true
    }]

    const moveStatus = (dragIndex: number, hoverIndex: number) => {
        const items = Array.from(updatedViewOrder);
        const [reorderedItem] = items.splice(dragIndex, 1);
        items.splice(hoverIndex, 0, reorderedItem);
        setupdatedViewOrder(items);
      };

      useEffect(() => {

        let result = updatedViewOrder?.length && updatedViewOrder?.map((item: any, index: any) => {
            return {id: item?.id, sequence: index+1}
        })
        setResultSequence(result)
      }, [updatedViewOrder])

    const onApplyClick = ()  => {
        const handleSuccess = (body: any) => {
            onCloseClick()
            getViewList(dispatch, model, "listing")
        }
        const handleFailure = (body: any) => {
            onCloseClick()
        }
        dispatch(bulkUpdateRequest("views", resultSequence, handleSuccess, handleFailure))
        onCloseClick()
        getViewList(dispatch, model, "listing")
      }

      
    return (
        <Modal backdrop="static" isOpen={show} toggle={onCloseClick} centered={true} size="xl">
            <ModalHeader className="p-3 offcanvas-header-dark d-flex flex-row justify-content-between align-items-center bg-primary" toggle={onCloseClick}>
                <span className='text-light'>{props.t("student.listing.breadcrumb.arrange_views")}</span>
            </ModalHeader>
            <ModalBody className='text-center p-5'>
                <div className="table-responsive">
                    <SimpleBar autoHide={false} className="simplebar-track-dark pe-2" style={{ maxHeight: "500px" }}>
                    {updatedViewOrder?.length && !loading ? ( 
                        <Table className="align-middle table-nowrap mb-0 table-hover">
                            <thead className='table-primary'>
                                <tr>
                                    <th className='border-bottom text-center table-soft-primary text-primary align-middle' scope="col">{props.t("student.listing.columns.view_name")}</th>
                                    <th className='border-bottom text-center table-soft-primary text-primary align-middle' scope="col">{props.t("student.listing.columns.location")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <DndProvider backend={HTML5Backend}>
                                {
                                    updatedViewOrder.map((value: any, valueIndex: number) => {
                                        return (
                                            <DNDRow
                                                key={value.value}
                                                index={valueIndex}
                                                id={value.value}
                                                value={value}
                                                moveRow={moveStatus}
                                                extraActions={extraActions}
                                                setRecord={setRecord} 
                                                setisDeleteOpen={setisDeleteOpen} 
                                                props={props} 
                                                model={model}
                                                viewId={viewId}
                                            />
                                        )
                                    })
                                }
                                </DndProvider>
                            </tbody>
                        </Table>
                        ) : loading ? (
                        <DtsTablePlaceholder
                            columns={3}
                            theadClass={'border-bottom-1 table-soft-primary  fw-bold'}
                            tableClass="align-middle table-nowrap"
                            thClass="border-bottom-1 table-soft-primary"
                        />
                        ) : (
                        <div className="text-center w-100 fs-16 fw-semibold">{props.t("common.table.no_views_to_show")}</div>
                        )}
                    </SimpleBar>
                </div>
            </ModalBody>

            <ModalFooter className='hstack justify-content-center'>
                <div className='hstack justify-content-center gap-2'>
                    <Button
                        onClick={() => onApplyClick()}
                        color="primary"
                        disabled={loading}
                        className="btn-label">
                        <i className="ri-magic-fill label-icon align-middle fs-16 me-2"></i>
                        {loading ? <Spinner size="sm" type="grow" className="flex-shrink-0" role="status"> Loading... </Spinner> : null } 
                        {props.t("common.offcanvas.apply")}
                    </Button>
                    <Button
                        onClick={() => { onCloseClick();}}
                        color="primary"
                        className="btn-soft-primary">
                        <i className="ri-layout-column-fill label-icon align-middle fs-16 me-2"></i>
                        {props.t("common.offcanvas.import_cancel")}
                    </Button>
                </div>
            </ModalFooter>

        </Modal>
    ) as unknown as JSX.Element;
};

export default ArrageViews;